import React, { createContext, useContext } from 'react';
import useFetch from 'hook/UseFetch';
import { UserService } from 'services/UserService';
import { useCookies } from 'react-cookie';
import { COOKIES_ACTIVATED } from 'utils/constants/cookies';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { GENERATE_ROUTE } from 'utils/constants/routes';
import { GENERAL_ACCOUNT_TABS_OBJECT } from 'utils/constants/tabs';
import CookieDialog from 'commons/CookieDialog/CookieDialog';

const UserInfoContext = createContext(null);
/**
 * @property {String} fullName
 * @property {int} id
 * @property {int} laboId
 * @property {String} laboName
 * @property {String} locale
 * @property {String} name
 * @typedef {String} role
 * @property {boolean} connectedAsUser
 */
// noinspection JSValidateTypes
/**
 * Return role of the current logged in user as string of the enum Roles
 * @returns {Privileges}
 */
export const useUserInfo = () => useContext(UserInfoContext);

export const UserInfoProvider = ({ children }) => {
  const privilege = useFetch(() => UserService.getUserInfo(), {}).response;
  const [cookies, setCookie] = useCookies([COOKIES_ACTIVATED]);
  const [open, setOpen] = React.useState(false);
  const history = useHistory();

  useEffect(() => {
    if (cookies[COOKIES_ACTIVATED] == null) {
      setOpen(true);
    }
  }, [privilege, cookies]);

  const agreeCookies = () => {
    setCookie(COOKIES_ACTIVATED, true);
    handleClose();
  };

  const declineCookies = () => {
    setCookie(COOKIES_ACTIVATED, false);
    handleClose();
  };

  const moreOptions = () => {
    setCookie(COOKIES_ACTIVATED, true);
    const url = getMoreOptionsUrl();
    return history.push(url);
  };

  const getMoreOptionsUrl = () => {
    handleClose();
    const url = window.location.href;

    if (!url.includes('/laboratory/')) {
      return GENERATE_ROUTE(GENERAL_ACCOUNT_TABS_OBJECT.COOKIES.ROUTE);
    } else {
      const laboratoryId = url.split('/').indexOf('laboratory') + 1;
      return GENERATE_ROUTE(GENERAL_ACCOUNT_TABS_OBJECT.COOKIES.ROUTE, url.split('/')[laboratoryId]);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <UserInfoContext.Provider
      value={privilege}
    >
      <CookieDialog
        onAgree={agreeCookies}
        onClose={handleClose}
        onDecline={declineCookies}
        onMoreOptions={moreOptions}
        open={open}/>
      {children}
    </UserInfoContext.Provider>
  );
};